// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  CanonicalAddress,
} from "./types";


export default __t.row({
  id: __t.string(),
  googlePlaceId: __t.option(__t.string()).name("google_place_id"),
  name: __t.option(__t.string()),
  businessType: __t.option(__t.string()).name("business_type"),
  heroCdnPath: __t.option(__t.string()).name("hero_cdn_path"),
  colorPrimary: __t.option(__t.string()).name("color_primary"),
  colorText: __t.option(__t.string()).name("color_text"),
  nominatedByClerkUserIdV1: __t.option(__t.string()).name("nominated_by_clerk_user_id_v_1"),
  totalInterested: __t.u32().name("total_interested"),
  get canonicalAddress() {
    return __t.option(CanonicalAddress).name("canonical_address");
  },
  submittedClaimRequest: __t.bool().name("submitted_claim_request"),
});
